import { render, staticRenderFns } from "./WebForm.vue?vue&type=template&id=b531a980&scoped=true&"
import script from "./WebForm.vue?vue&type=script&lang=js&"
export * from "./WebForm.vue?vue&type=script&lang=js&"
import style0 from "./WebForm.vue?vue&type=style&index=0&id=b531a980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b531a980",
  null
  
)

export default component.exports